export default {
  methods: {
    checkEmail (email) {
      const regExp = /^[0-9a-zA-Z][0-9a-zA-Z\_\-\.\+]+[0-9a-zA-Z]@[0-9a-zA-Z][0-9a-zA-Z\_\-]*[0-9a-zA-Z](\.[a-zA-Z]{2,6}){1,2}$/

      return regExp.test(email)
    },
    checkPhoneNo (phoneNo, isMobile) {
      const mobile = /^01([0|1|6|7|8|9]?)-?([0-9]{3,4})-?([0-9]{4})$/
      const notMobile = /^\d{2,3}\d{3,4}\d{4}$/
      const regExp = isMobile ? mobile : notMobile
      return regExp.test(phoneNo)
    }
  }
}
